import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	childRoute: {
		boxSizing: 'border-box',
		height: '100%',
		overflow: 'auto',
	},
	recipientContainer: {
		width: 360,
	},
	container: {
		height: '100%',
		width: '100%',
	},
});
